/**
 * ----------------------------------------------------------------------------------------------
 * individual JS for Custom collection search Logic
 * ----------------------------------------------------------------------------------------------
 */


// ------------------------------
// Start : 商品データ取得ロジック
// ------------------------------
let productList = [],
productList_Original = [];
const fetchProductListObject = {};
current_page = 1;
const fetchSectionName = "for-search-logic";
const currentUrl = location.pathname;
const dips_per_page = 50;
const loadingOverlay = document.getElementById('page-loading-overlay'),
  productCount = document.getElementById("ProductCount"),
  productCountDrawer = document.getElementById("ProductCount-Drawer"),
  activeFacetsCounter = document.getElementById("active-facets-counter");

let start;

// ーーー 取得ページ件数(1~5ページ) ーーー
const sectionUrlItems = [
  `${currentUrl}?view=${fetchSectionName}&page=1`,
  `${currentUrl}?view=${fetchSectionName}&page=2`,
  `${currentUrl}?view=${fetchSectionName}&page=3`,
  `${currentUrl}?view=${fetchSectionName}&page=4`,
  `${currentUrl}?view=${fetchSectionName}&page=5`,
  `${currentUrl}?view=${fetchSectionName}&page=6`,
  `${currentUrl}?view=${fetchSectionName}&page=7`,
  `${currentUrl}?view=${fetchSectionName}&page=8`,
  `${currentUrl}?view=${fetchSectionName}&page=9`,
  `${currentUrl}?view=${fetchSectionName}&page=10`,
  `${currentUrl}?view=${fetchSectionName}&page=11`,
  `${currentUrl}?view=${fetchSectionName}&page=12`,
  `${currentUrl}?view=${fetchSectionName}&page=13`,
  `${currentUrl}?view=${fetchSectionName}&page=14`,
  `${currentUrl}?view=${fetchSectionName}&page=15`,
  `${currentUrl}?view=${fetchSectionName}&page=16`,
  `${currentUrl}?view=${fetchSectionName}&page=17`,
  `${currentUrl}?view=${fetchSectionName}&page=18`,
  `${currentUrl}?view=${fetchSectionName}&page=19`,
  `${currentUrl}?view=${fetchSectionName}&page=20`,
  `${currentUrl}?view=${fetchSectionName}&page=21`,
  `${currentUrl}?view=${fetchSectionName}&page=22`,
  `${currentUrl}?view=${fetchSectionName}&page=23`,
  `${currentUrl}?view=${fetchSectionName}&page=24`,
  `${currentUrl}?view=${fetchSectionName}&page=25`,
  `${currentUrl}?view=${fetchSectionName}&page=26`,
  `${currentUrl}?view=${fetchSectionName}&page=27`,
  `${currentUrl}?view=${fetchSectionName}&page=28`,
  `${currentUrl}?view=${fetchSectionName}&page=29`,
  `${currentUrl}?view=${fetchSectionName}&page=30`,
  `${currentUrl}?view=${fetchSectionName}&page=31`,
  `${currentUrl}?view=${fetchSectionName}&page=32`,
];

let firstViewFlg = true,
  paginationFlg = false,
  filterFlg = false,
  freeWord = "",
  firstSelectedValue = "",
  sortByValue = "";

(async ()=>{
  //初期化処理

  // 並び替えパラメータがある場合はURLパラメータに追加
  // 現在のURLからsort_byパラメータを取得
  const initialUrlObj = new URL(window.location.href);
  const initialSortByValue = initialUrlObj.searchParams.get("sort_by");
  if(initialSortByValue && initialSortByValue.length > 0) {
    sortByValue = initialSortByValue;
  }

  const start = performance.now();
  console.log('start:', start);

  await Promise.all(sectionUrlItems.map(async (urlItem) => {
    await fetchItem(urlItem);
  }));

  console.log("fetchProductListObject",JSON.parse(JSON.stringify(fetchProductListObject)));

  // fetchProductListObjectを商品の配列に変換
  productList_Original = Object.values(fetchProductListObject).flat();
  console.log("productList_Original",JSON.parse(JSON.stringify(productList_Original)));

  // 絞り込み条件を動的生成
  generateAndRenderFilters();

  // URLパラメータから初期絞り込み条件を適用
  applyInitialFiltersFromURL();

  return;

}).call();


//初期化処理 true/falseを返し、reduce()した処理で全てtrueならPromise 成功
async function fetchItem(_sectionUrl) {
  let sectionUrl = _sectionUrl;

  // sortByValueがある場合はURLパラメータに追加
  if(sortByValue.length > 0) {
    const urlObj = new URL(sectionUrl, window.location.origin);
    urlObj.searchParams.set("sort_by", sortByValue);
    sectionUrl = urlObj.toString();
  }

  const requestChangeOptions = {
    credentials: 'same-origin',
    method: 'GET'
  }

  //await fetch 通信成功時にtrue / 失敗時にfalseを返す
  await fetch(sectionUrl, requestChangeOptions)
    .then(response => response.text())
    .then(content => {
      // fetch通信成功時処理
      const dom_wrapper = document.createElement('div');
      dom_wrapper.innerHTML = content;
      const dom_product_list = dom_wrapper.querySelector('.shopify-section').textContent;
      const parsedProductList = JSON.parse(dom_product_list);

      const pageParam = sectionUrl.split("&").find(param => param.includes("page="))?.split("page=")[1];

      fetchProductListObject[pageParam] = parsedProductList;

      return true
    })
    .catch(error => {
      console.error(error);
      return false
    });
}

// ------------------------------
// Start : 商品レンダリング & Infinite Scroll
// ------------------------------
const PRODUCTS_PER_PAGE = 24;
let currentRenderPage = 0;

// 商品件数を更新
function updateProductCount(count) {
  const countElements = document.querySelectorAll('.c-collection-banner__products-count');

  countElements.forEach(element => {
    const suffix = element.dataset.allCountText;

    element.textContent = `${count.toLocaleString()}${suffix}`;
  });

  console.log(`Product count updated: ${count}`);
}

// 初期24商品をレンダリング
function renderInitialProducts() {
  const container = document.querySelector('.product-list__inner');
  if (!container) {
    console.error('product-list__inner not found');
    return;
  }

  // 商品件数を更新
  updateProductCount(productList_Original.length);

  // 初期表示商品をレンダリング
  renderProducts(0, PRODUCTS_PER_PAGE);
  currentRenderPage = 1;

  // Infinite Scroll用のトリガー要素を追加
  if (productList_Original.length > PRODUCTS_PER_PAGE) {
    addInfiniteScrollElements(container);
  }
}

// 指定範囲の商品をレンダリング
function renderProducts(startIndex, endIndex) {
  const container = document.querySelector('.product-list__inner');
  if (!container) return;

  const productsToRender = productList_Original.slice(startIndex, endIndex);

  productsToRender.forEach((product, index) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = product.item_html.trim();
    const productElement = wrapper.firstChild;

    // フェードインアニメーション用のスタイル設定
    if (startIndex > 0) { // 初期表示以外の場合
      productElement.style.opacity = '0';
      productElement.style.transform = 'translateY(20px)';
      container.appendChild(productElement);

      setTimeout(() => {
        productElement.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        productElement.style.opacity = '1';
        productElement.style.transform = 'translateY(0)';
      }, index * 100);
    } else {
      container.appendChild(productElement);
    }
  });
}

// Infinite Scroll用の要素を追加
function addInfiniteScrollElements(container) {
  const triggerHTML = `
    <div class="infinite-scroll-trigger-all" style="width: 100%; height: 20px; visibility: hidden;"></div>
    <div class="infinite-scroll-loading-all" style="display: none; justify-content: center; align-items: center; padding: 20px 0; width: 100%;">
      <div class="loading-spinner" style="width: 30px; height: 30px; border: 2px solid #f3f3f3; border-top: 2px solid #333; border-radius: 50%; animation: spin 1s linear infinite; margin-right: 10px;"></div>
      <span class="loading-text" style="font-size: 14px; color: #666;">読み込み中...</span>
    </div>
    <div class="infinite-scroll-end-all" style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%) translateY(100%); background-color: rgba(0, 0, 0, 0.8); color: white; padding: 12px 24px; border-radius: 4px; font-size: 14px; opacity: 0; visibility: hidden; transition: all 0.3s ease; z-index: 1000;">
      <span class="end-message" style="display: block; text-align: center; white-space: nowrap;">すべての商品を表示しました</span>
    </div>
  `;

  container.insertAdjacentHTML('afterend', triggerHTML);
}

// Infinite Scroll クラス
class InfiniteScrollForAll {
  constructor() {
    this.isLoading = false;
    this.currentPage = 1;
    this.trigger = document.querySelector('.infinite-scroll-trigger-all');
    this.loadingElement = document.querySelector('.infinite-scroll-loading-all');
    this.endMessage = document.querySelector('.infinite-scroll-end-all');
    this.observer = null;

    if (this.trigger && this.loadingElement) {
      this.init();
    }
  }

  init() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadNextPage();
          }
        });
      },
      {
        rootMargin: '50px',
        threshold: 0.1
      }
    );

    this.observer.observe(this.trigger);
  }

  showEndMessage() {
    if (this.endMessage) {
      this.endMessage.style.transform = 'translateX(-50%) translateY(0)';
      this.endMessage.style.opacity = '1';
      this.endMessage.style.visibility = 'visible';

      setTimeout(() => {
        this.endMessage.style.transform = 'translateX(-50%) translateY(100%)';
        this.endMessage.style.opacity = '0';
        this.endMessage.style.visibility = 'hidden';
      }, 3000);
    }
  }

  async loadNextPage() {
    if (this.isLoading) return;

    const startIndex = this.currentPage * PRODUCTS_PER_PAGE;
    const endIndex = startIndex + PRODUCTS_PER_PAGE;

    // すべての商品を表示済みかチェック
    if (startIndex >= productList_Original.length) {
      this.observer.disconnect();
      if (this.trigger) this.trigger.remove();
      this.showEndMessage();
      return;
    }

    this.isLoading = true;
    this.loadingElement.style.display = 'flex';

    try {
      // 次のページの商品をレンダリング
      await new Promise(resolve => setTimeout(resolve, 300)); // ローディング表示のため少し待機
      renderProducts(startIndex, endIndex);
      this.currentPage++;

      // まだ表示していない商品がある場合は継続
      if (endIndex >= productList_Original.length) {
        this.observer.disconnect();
        if (this.trigger) this.trigger.remove();
        this.showEndMessage();
      }

    } catch (error) {
      console.error('Infinite scroll error:', error);
      this.observer.disconnect();
      if (this.trigger) this.trigger.remove();
      this.showEndMessage();
    } finally {
      this.isLoading = false;
      this.loadingElement.style.display = 'none';
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

// Infinite Scroll初期化
let infiniteScrollForAll;

function initInfiniteScrollForAll() {
  if (infiniteScrollForAll) {
    infiniteScrollForAll.destroy();
  }

  // 商品が24個以上ある場合のみInfinite Scrollを有効化
  if (productList_Original.length > PRODUCTS_PER_PAGE) {
    infiniteScrollForAll = new InfiniteScrollForAll();
  }
}

// ------------------------------
// Start : 並び替え処理
// ------------------------------

// 商品一覧とInfinite Scroll要素をクリア
function clearProducts() {
  const container = document.querySelector('.product-list__inner');
  if (container) {
    container.innerHTML = '';
  }

  // Infinite Scroll要素を削除
  const trigger = document.querySelector('.infinite-scroll-trigger-all');
  const loading = document.querySelector('.infinite-scroll-loading-all');
  const endMsg = document.querySelector('.infinite-scroll-end-all');

  if (trigger) trigger.remove();
  if (loading) loading.remove();
  if (endMsg) endMsg.remove();

  // Infinite Scrollインスタンスを破棄
  if (infiniteScrollForAll) {
    infiniteScrollForAll.destroy();
    infiniteScrollForAll = null;
  }
}

// 再取得と再レンダリング
async function refetchAndRender() {
  // ローディング表示
  if (loadingOverlay) {
    loadingOverlay.classList.add('is-visible');
  }

  try {
    // fetchProductListObjectをクリア
    Object.keys(fetchProductListObject).forEach(key => {
      delete fetchProductListObject[key];
    });

    // 並列処理で全ページ再取得
    await Promise.all(sectionUrlItems.map(async (urlItem) => {
      await fetchItem(urlItem);
    }));

    productList_Original = Object.values(fetchProductListObject).flat();

    // アクティブフィルターが存在する場合は絞り込みを適用
    const hasActiveFilters = Object.values(activeFilters).some(arr => Array.isArray(arr) && arr.length > 0);

    if (hasActiveFilters) {
      // 絞り込みを適用
      const filtered = filterProducts(activeFilters);
      updateProductDisplay(filtered);
      renderActiveFilters();
    } else {
      // フィルターがない場合は全商品を表示
      renderInitialProducts();
      initInfiniteScrollForAll();
    }

  } catch (error) {
    console.error('Refetch error:', error);
  } finally {
    // ローディング非表示
    if (loadingOverlay) {
      loadingOverlay.classList.remove('is-visible');
    }
  }
}

window.sortByForAllCollection = async (currentUrl, targetValue) => {
  // 並び替え値を更新
  sortByValue = targetValue;

  // 既存の商品一覧をクリア
  clearProducts();

  // 並び替えパラメータ付きで再取得&再レンダリング
  await refetchAndRender();

  // URLを更新
  updateURL();
}

// ------------------------------
// Start : 絞り込み処理
// ------------------------------

// アクティブフィルターの状態を保持
let activeFilters = {
  product_type: [],
  size: [],
  color: [],
  pattern_flg: [],
  material: [],
  price: { gte: null, lte: null }
};

// フィルターラベルのマッピング
const filterLabels = {
  product_vendor: 'カテゴリー',
  product_type: '分類',
  size: '寸法',
  color: '色',
  price: '価格',
  pattern_flg: '無地',
  material: '素材',
};

// URLパラメータから絞り込み条件を解析
function parseFilterParams(searchParamsAsString) {
  const params = new URLSearchParams(searchParamsAsString);
  const filters = {
    product_type: [],
    size: [],
    color: [],
    pattern_flg: [],
    material: [],
    price: { gte: null, lte: null }
  };

  for (const [key, value] of params.entries()) {
    // 空文字列は除外
    if (!value || value.trim() === '') continue;

    if (key === 'filter.p.product_type') {
      filters.product_type.push(value);
    } else if (key === 'filter.v.option.size') {
      filters.size.push(value);
    } else if (key === 'filter.p.m.item.color') {
      filters.color.push(value);
    } else if (key === 'filter.p.m.item.pattern_flg') {
      filters.pattern_flg.push(value);
    } else if (key === 'filter.p.m.item.material') {
      filters.material.push(value);
    } else if (key === 'filter.v.price.gte') {
      const parsed = parseInt(value, 10);
      if (!Number.isNaN(parsed)) filters.price.gte = parsed;
    } else if (key === 'filter.v.price.lte') {
      const parsed = parseInt(value, 10);
      if (!Number.isNaN(parsed)) filters.price.lte = parsed;
    }
  }

  return filters;
}

// アクティブフィルター数を取得（price は gte/lte のいずれか指定で1件とみなす）
function getActiveFiltersCount(filters) {
  let count = 0;
  Object.keys(filters).forEach((key) => {
    if (key === 'price') {
      const hasPrice = filters.price && (filters.price.gte != null || filters.price.lte != null);
      if (hasPrice) count += 1;
      return;
    }
    const values = filters[key];
    if (Array.isArray(values)) count += values.length;
  });
  return count;
}

// productList_Originalを絞り込み
function filterProducts(filters) {
  let filteredProducts = [...productList_Original];

  // product_typeで絞り込み
  if (filters.product_type.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      return filters.product_type.includes(product.product_type);
    });
  }

  // sizeで絞り込み（商品のsize配列にいずれかが含まれる）
  if (filters.size.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      if (!product.size || !Array.isArray(product.size)) return false;
      return filters.size.some(filterSize => product.size.includes(filterSize));
    });
  }

  // colorで絞り込み（商品のcolor配列にいずれかが含まれる）
  if (filters.color.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      if (!product.color || !Array.isArray(product.color)) return false;
      return filters.color.some(filterColor => product.color.includes(filterColor));
    });
  }

  // pattern_flgで絞り込み
  if (filters.pattern_flg.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      return filters.pattern_flg.some(flg => {
        const boolValue = flg === 'true' || flg === '1';
        return product.pattern_flg === boolValue;
      });
    });
  }

  // materialで絞り込み（商品のmaterial配列にいずれかが含まれる）
  if (filters.material.length > 0) {
    filteredProducts = filteredProducts.filter(product => {
      if (!product.material || !Array.isArray(product.material)) return false;
      return filters.material.some(filterMaterial => product.material.includes(filterMaterial));
    });
  }

  // priceで絞り込み（product_min_price / product_max_price を利用）
  if (filters.price && (filters.price.gte != null || filters.price.lte != null)) {
    const minPrice = filters.price.gte != null ? filters.price.gte * 100 : null; // input は通貨単位、商品は cents
    const maxPrice = filters.price.lte != null ? filters.price.lte * 100 : null;

    filteredProducts = filteredProducts.filter(product => {
      const productMin = typeof product.product_min_price === 'number' ? product.product_min_price : null;
      const productMax = typeof product.product_max_price === 'number' ? product.product_max_price : null;

      if (productMin == null && productMax == null) return false;

      // 下限チェック
      if (minPrice != null) {
        if (productMax != null && productMax < minPrice) return false;
        if (productMax == null && productMin != null && productMin < minPrice) return false;
      }

      // 上限チェック
      if (maxPrice != null) {
        if (productMin != null && productMin > maxPrice) return false;
        if (productMin == null && productMax != null && productMax > maxPrice) return false;
      }

      return true;
    });
  }

  return filteredProducts;
}

// 絞り込み結果を表示更新
let filteredProductList = [];

function updateProductDisplay(products) {
  // 絞り込み結果を保存
  filteredProductList = products;

  // 既存の商品一覧をクリア
  clearProducts();

  // 商品件数を更新
  updateProductCount(filteredProductList.length);

  // 絞り込み結果が0件の場合
  const emptyState = document.querySelector('[data-empty-state-for-all-collection]');
  if (filteredProductList.length === 0) {
    if (emptyState) {
      emptyState.removeAttribute('hidden');
    }
    return;
  } else {
    if (emptyState) {
      emptyState.setAttribute('hidden', '');
    }
  }

  // 初期24商品をレンダリング（絞り込み結果から）
  renderFilteredProducts(0, PRODUCTS_PER_PAGE);

  // Infinite Scroll用のトリガー要素を追加
  const container = document.querySelector('.product-list__inner');
  if (filteredProductList.length > PRODUCTS_PER_PAGE && container) {
    addInfiniteScrollElements(container);
    initInfiniteScrollForFiltered();
  }
}

// 絞り込み結果から指定範囲の商品をレンダリング
function renderFilteredProducts(startIndex, endIndex) {
  const container = document.querySelector('.product-list__inner');
  if (!container) return;

  const productsToRender = filteredProductList.slice(startIndex, endIndex);

  productsToRender.forEach((product, index) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = product.item_html.trim();
    const productElement = wrapper.firstChild;

    // フェードインアニメーション用のスタイル設定
    if (startIndex > 0) {
      productElement.style.opacity = '0';
      productElement.style.transform = 'translateY(20px)';
      container.appendChild(productElement);

      setTimeout(() => {
        productElement.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        productElement.style.opacity = '1';
        productElement.style.transform = 'translateY(0)';
      }, index * 100);
    } else {
      container.appendChild(productElement);
    }
  });
}

// 絞り込み結果用のInfinite Scroll
class InfiniteScrollForFiltered {
  constructor() {
    this.isLoading = false;
    this.currentPage = 1;
    this.trigger = document.querySelector('.infinite-scroll-trigger-all');
    this.loadingElement = document.querySelector('.infinite-scroll-loading-all');
    this.endMessage = document.querySelector('.infinite-scroll-end-all');
    this.observer = null;

    if (this.trigger && this.loadingElement) {
      this.init();
    }
  }

  init() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadNextPage();
          }
        });
      },
      {
        rootMargin: '50px',
        threshold: 0.1
      }
    );

    this.observer.observe(this.trigger);
  }

  showEndMessage() {
    if (this.endMessage) {
      this.endMessage.style.transform = 'translateX(-50%) translateY(0)';
      this.endMessage.style.opacity = '1';
      this.endMessage.style.visibility = 'visible';

      setTimeout(() => {
        this.endMessage.style.transform = 'translateX(-50%) translateY(100%)';
        this.endMessage.style.opacity = '0';
        this.endMessage.style.visibility = 'hidden';
      }, 3000);
    }
  }

  async loadNextPage() {
    if (this.isLoading) return;

    const startIndex = this.currentPage * PRODUCTS_PER_PAGE;
    const endIndex = startIndex + PRODUCTS_PER_PAGE;

    if (startIndex >= filteredProductList.length) {
      this.observer.disconnect();
      if (this.trigger) this.trigger.remove();
      this.showEndMessage();
      return;
    }

    this.isLoading = true;
    this.loadingElement.style.display = 'flex';

    try {
      await new Promise(resolve => setTimeout(resolve, 300));
      renderFilteredProducts(startIndex, endIndex);
      this.currentPage++;

      if (endIndex >= filteredProductList.length) {
        this.observer.disconnect();
        if (this.trigger) this.trigger.remove();
        this.showEndMessage();
      }

    } catch (error) {
      console.error('Infinite scroll error:', error);
      this.observer.disconnect();
      if (this.trigger) this.trigger.remove();
      this.showEndMessage();
    } finally {
      this.isLoading = false;
      this.loadingElement.style.display = 'none';
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

let infiniteScrollForFiltered;

function initInfiniteScrollForFiltered() {
  if (infiniteScrollForFiltered) {
    infiniteScrollForFiltered.destroy();
  }

  if (filteredProductList.length > PRODUCTS_PER_PAGE) {
    infiniteScrollForFiltered = new InfiniteScrollForFiltered();
  }
}

window.filterForAllCollection = async (searchParamsAsString) => {

  // URLパラメータから絞り込み条件を解析
  const filters = parseFilterParams(searchParamsAsString);

  // アクティブフィルターを更新
  activeFilters = { ...filters };

  // productList_Originalから絞り込み
  const filtered = filterProducts(filters);

  // 絞り込み結果を表示
  updateProductDisplay(filtered);

  // アクティブフィルターを表示
  renderActiveFilters();

  // URLを更新
  updateURL();
}

// ------------------------------
// Start : アクティブフィルターの表示・削除
// ------------------------------

// アクティブフィルターを表示
function renderActiveFilters() {
  const activeFilterContainers = document.querySelectorAll('[data-active-facets-for-all-collection]');

  if (activeFilterContainers.length === 0) {
    console.error('data-active-facets-for-all-collection not found');
    return;
  }

  // アクティブフィルターの数をカウント（priceは1と数える）
  const activeCount = getActiveFiltersCount(activeFilters);

  // HTMLを生成
  const tagsHTML = generateActiveFilterTags();
  const clearAllHTML = activeCount > 1 ? generateClearAllButton() : '';

  // すべてのコンテナに適用
  console.log("activeFilterContainers",activeFilterContainers);
  activeFilterContainers.forEach(container => {
    container.innerHTML = tagsHTML + clearAllHTML;
  });

  // [data-action="clear-filters-for-all-collection"]ボタンの表示制御
  const clearFiltersButtons = document.querySelectorAll('[data-action="clear-filters-for-all-collection"]');
  clearFiltersButtons.forEach(button => {
    if (activeCount > 0) {
      button.removeAttribute('hidden');
    } else {
      button.setAttribute('hidden', '');
    }
  });

  // イベントリスナーを設定
  attachActiveFilterEvents();
}

// アクティブフィルタータグのHTML生成
function generateActiveFilterTags() {
  const tags = [];

  Object.keys(activeFilters).forEach(filterType => {
    const values = activeFilters[filterType];
    if (Array.isArray(values) && values.length > 0) {
      values.forEach(value => {
        const label = filterLabels[filterType];
        const displayValue = filterType === 'pattern_flg' ? label : `${label}: ${value}`;

        tags.push(`
          <div class="tag">
            ${displayValue}
            <button type="button" class="tag__icon tap-area" data-filter-type="${filterType}" data-filter-value="${value}" aria-label="削除" style="background: transparent;">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L11 11" stroke="black" stroke-linecap="round"/>
                <path d="M1 11L11 1" stroke="black" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        `);
      });
    } else if (filterType === 'price' && values && (values.gte != null || values.lte != null)) {
      const label = filterLabels[filterType];
      const from = values.gte != null ? values.gte.toLocaleString() : '0';
      const to = values.lte != null ? values.lte.toLocaleString() : getMaxPriceYenFromProducts().toLocaleString();
      tags.push(`
        <div class="tag">
          ${label}: ${from} - ${to}
          <button type="button" class="tag__icon tap-area" data-filter-type="price" data-filter-value="__all__" aria-label="削除" style="background: transparent;">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L11 11" stroke="black" stroke-linecap="round"/>
              <path d="M1 11L11 1" stroke="black" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      `);
    }
  });

  return tags.join('');
}

// 現在の全商品の最大価格(円)を取得
function getMaxPriceYenFromProducts() {
  let maxCents = 0;
  if (Array.isArray(productList_Original)) {
    productList_Original.forEach((product) => {
      const productMax = typeof product.product_max_price === 'number' ? product.product_max_price : 0;
      if (productMax > maxCents) maxCents = productMax;
    });
  }
  return Math.ceil(maxCents / 100);
}

// 「すべてクリア」ボタンのHTML生成
function generateClearAllButton() {
  return `
    <button type="button" class="tag-link link text--subdued" data-action="clear-all-filters">すべてクリア</button>
  `;
}

// アクティブフィルターのイベントリスナーを設定
function attachActiveFilterEvents() {
  // 個別削除ボタン
  document.querySelectorAll('[data-filter-type]').forEach(button => {
    button.addEventListener('click', (e) => {
      const filterType = e.currentTarget.getAttribute('data-filter-type');
      const filterValue = e.currentTarget.getAttribute('data-filter-value');
      removeActiveFilter(filterType, filterValue);
    });
  });

  // すべてクリアボタン
  document.querySelectorAll('[data-action="clear-all-filters"]').forEach(button => {
    button.addEventListener('click', () => {
      clearAllFilters();
    });
  });

  // クリアフィルターボタン（drawer内）
  document.querySelectorAll('[data-action="clear-filters-for-all-collection"]').forEach(button => {
    button.addEventListener('click', () => {
      clearAllFilters();
    });
  });
}

// 個別フィルターを削除
function removeActiveFilter(filterType, filterValue) {

  // アクティブフィルターから削除
  if (Array.isArray(activeFilters[filterType])) {
    activeFilters[filterType] = activeFilters[filterType].filter(v => v !== filterValue);
  } else if (filterType === 'price') {
    activeFilters.price = { gte: null, lte: null };
  }

  // フォームのチェックボックス/セレクトも更新
  updateFormControls();

  // 絞り込みを再実行
  const filtered = filterProducts(activeFilters);
  updateProductDisplay(filtered);
  renderActiveFilters();

  // URLを更新
  updateURL();
}

// すべてのフィルターをクリア
function clearAllFilters() {

  // アクティブフィルターをリセット
  activeFilters = {
    product_type: [],
    size: [],
    color: [],
    pattern_flg: [],
    material: [],
    price: { gte: null, lte: null }
  };

  // フォームのチェックボックス/セレクトも更新
  updateFormControls();

  // 全商品を表示
  updateProductDisplay(productList_Original);
  renderActiveFilters();

  // URLを更新
  updateURL();
}

// フォームコントロールを更新（チェックボックス、セレクトボックスの状態を同期）
function updateFormControls() {
  const form = document.getElementById('facet-filters-form');
  if (!form) return;

  // すべてのチェックボックスとセレクトをリセット
  form.querySelectorAll('input[type="checkbox"]').forEach(input => {
    input.checked = false;
  });

  form.querySelectorAll('select').forEach(select => {
    select.value = '';
  });

  // 価格入力の初期化（PriceRangeの入力/レンジ）
  const priceLowerInput = form.querySelector('input[name="filter.v.price.gte"]');
  const priceUpperInput = form.querySelector('input[name="filter.v.price.lte"]');
  const priceRange = document.querySelector('price-range');
  if (priceLowerInput) priceLowerInput.value = '';
  if (priceUpperInput) priceUpperInput.value = '';
  if (priceRange) {
    const lowerRange = priceRange.querySelector('.price-range__range-group input:first-child');
    const higherRange = priceRange.querySelector('.price-range__range-group input:last-child');
    const textLower = priceRange.querySelector('.price-range__input:first-child input');
    const textHigher = priceRange.querySelector('.price-range__input:last-child input');
    if (lowerRange && higherRange && textLower && textHigher) {
      // デフォルトに戻す
      const min = parseInt(lowerRange.min || '0', 10) || 0;
      const max = parseInt(higherRange.max || textHigher.placeholder || '0', 10) || 0;
      lowerRange.value = String(min);
      higherRange.value = String(max);
      textLower.value = '';
      textHigher.value = '';
      lowerRange.parentElement.style.setProperty('--range-min', `${(parseInt(lowerRange.value) / parseInt(lowerRange.max || '1')) * 100}%`);
      higherRange.parentElement.style.setProperty('--range-max', `${(parseInt(higherRange.value) / parseInt(higherRange.max || '1')) * 100}%`);
    }
  }

  // アクティブフィルターに基づいて再チェック
  Object.keys(activeFilters).forEach(filterType => {
    const values = activeFilters[filterType];

    if (filterType === 'product_type' && values.length > 0) {
      const select = form.querySelector('select[name="filter.p.product_type"]');
      if (select) select.value = values[0];
    } else if (Array.isArray(values)) {
      values.forEach(value => {
        let selector = '';
        if (filterType === 'size') {
          selector = `input[name="filter.v.option.size"][value="${value}"]`;
        } else if (filterType === 'color') {
          selector = `input[name="filter.p.m.item.color"][value="${value}"]`;
        } else if (filterType === 'pattern_flg') {
          selector = `input[name="filter.p.m.item.pattern_flg"]`;
        } else if (filterType === 'material') {
          selector = `input[name="filter.p.m.item.material"][value="${value}"]`;
        }

        const input = form.querySelector(selector);
        if (input) input.checked = true;
      });
    } else if (filterType === 'price' && values && (values.gte != null || values.lte != null)) {
      const lower = form.querySelector('input[name="filter.v.price.gte"]');
      const upper = form.querySelector('input[name="filter.v.price.lte"]');
      if (lower && values.gte != null) lower.value = String(values.gte);
      if (upper && values.lte != null) upper.value = String(values.lte);
      const priceRange = document.querySelector('price-range');
      if (priceRange) {
        const lowerRange = priceRange.querySelector('.price-range__range-group input:first-child');
        const higherRange = priceRange.querySelector('.price-range__range-group input:last-child');
        const textLower = priceRange.querySelector('.price-range__input:first-child input');
        const textHigher = priceRange.querySelector('.price-range__input:last-child input');
        if (values.gte != null) {
          if (textLower) textLower.value = String(values.gte);
          if (lowerRange) {
            lowerRange.value = String(values.gte);
            lowerRange.parentElement.style.setProperty('--range-min', `${(parseInt(lowerRange.value) / parseInt(lowerRange.max || '1')) * 100}%`);
          }
        }
        if (values.lte != null) {
          if (textHigher) textHigher.value = String(values.lte);
          if (higherRange) {
            higherRange.value = String(values.lte);
            higherRange.parentElement.style.setProperty('--range-max', `${(parseInt(higherRange.value) / parseInt(higherRange.max || '1')) * 100}%`);
          }
        }
      }
    }
  });
}

// ------------------------------
// Start : 絞り込み条件の動的生成
// ------------------------------

// productList_Originalから絞り込み条件を集計
function generateFilterOptions() {
  const options = {
    product_vendor: new Set(),
    product_type: new Set(),
    size: new Set(),
    color: new Set(),
    pattern_flg: false,
    material: new Set(),
    price: { min: 0, max: 0 }
  };

  productList_Original.forEach(product => {
    // product_vendor
    if (product.product_vendor) {
      options.product_vendor.add(product.product_vendor);
    }

    // product_type
    if (product.product_type) {
      options.product_type.add(product.product_type);
    }

    // size (配列)
    if (product.size && Array.isArray(product.size)) {
      product.size.forEach(s => options.size.add(s));
    }

    // color (配列)
    if (product.color && Array.isArray(product.color)) {
      product.color.forEach(c => options.color.add(c));
    }

    // pattern_flg
    if (product.hasOwnProperty('pattern_flg')) {
      options.pattern_flg = true;
    }

    // material (配列)
    if (product.material && Array.isArray(product.material)) {
      product.material.forEach(m => options.material.add(m));
    }

    // price range
    if (typeof product.product_min_price === 'number') {
      const pMin = Math.floor(product.product_min_price / 100);
      if (options.price.min === 0 || pMin < options.price.min) options.price.min = pMin;
    }
    if (typeof product.product_max_price === 'number') {
      const pMax = Math.ceil(product.product_max_price / 100);
      if (pMax > options.price.max) options.price.max = pMax;
    }
  });

  // Setを配列に変換してソート
  return {
    product_vendor: Array.from(options.product_vendor).sort(),
    product_type: Array.from(options.product_type).sort(),
    size: Array.from(options.size).sort(),
    color: Array.from(options.color).sort(),
    pattern_flg: options.pattern_flg,
    material: Array.from(options.material).sort(),
    price: options.price
  };
}

// product_vendor用のセレクトボックスHTML生成
function generateProductVendorHTML(productVendors) {
  if (productVendors.length === 0) return '';

  const optionsHTML = productVendors.map(vendor =>
    `<option value="${vendor}">${vendor} &lrm;</option>`
  ).join('\n                      ');

  return `
          <div class="product-facet__filter-item">
            <button
              type="button"
              is="toggle-button"
              class="collapsible-toggle text--strong"
              aria-controls="facet-filter-filter.p.product_vendor"
              aria-expanded="false"
            >
              カテゴリー<span class="c-collapsible-plus"></span></button
            ><collapsible-content animate-items="" id="facet-filter-filter.p.product_vendor" class="collapsible">
              <div class="collapsible__content">
                <div class="input">
                  <div class="select-wrapper">
                    <select id="filter.p.product_vendor" class="select" name="filter.p.product_vendor" value="">
                      <option value="">すべて</option>
                      ${optionsHTML}
                    </select>
                    <svg
                      focusable="false"
                      width="16"
                      height="10"
                      class="icon icon--chevron-bold   "
                      viewBox="0 0 16 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7.28899 8.72468C7.67951 9.11521 8.31268 9.11521 8.7032 8.72468L15.0672 2.36072C15.4577 1.9702 15.4577 1.33703 15.0672 0.94651C14.6766 0.555986 14.0435 0.555986 13.6529 0.94651L7.99609 6.60336L2.33924 0.94651C1.94872 0.555986 1.31555 0.555986 0.925026 0.94651C0.534502 1.33703 0.534502 1.9702 0.925026 2.36072L7.28899 8.72468ZM7.99609 7.01758H6.99609V8.01758H7.99609H8.99609V7.01758H7.99609Z" fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </collapsible-content>
          </div>`;
}

// product_type用のセレクトボックスHTML生成
function generateProductTypeHTML(productTypes) {
  if (productTypes.length === 0) return '';

  const optionsHTML = productTypes.map(type =>
    `<option value="${type}">${type} &lrm;</option>`
  ).join('\n                      ');

  return `
          <div class="product-facet__filter-item">
            <button
              type="button"
              is="toggle-button"
              class="collapsible-toggle text--strong"
              aria-controls="facet-filter-filter.p.product_type"
              aria-expanded="false"
            >
              分類<span class="c-collapsible-plus"></span></button
            ><collapsible-content animate-items="" id="facet-filter-filter.p.product_type" class="collapsible">
              <div class="collapsible__content">
                <div class="input">
                  <div class="select-wrapper">
                    <select id="filter.p.product_type" class="select" name="filter.p.product_type" value="">
                      <option value="">すべて</option>
                      ${optionsHTML}
                    </select>
                    <svg
                      focusable="false"
                      width="16"
                      height="10"
                      class="icon icon--chevron-bold   "
                      viewBox="0 0 16 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7.28899 8.72468C7.67951 9.11521 8.31268 9.11521 8.7032 8.72468L15.0672 2.36072C15.4577 1.9702 15.4577 1.33703 15.0672 0.94651C14.6766 0.555986 14.0435 0.555986 13.6529 0.94651L7.99609 6.60336L2.33924 0.94651C1.94872 0.555986 1.31555 0.555986 0.925026 0.94651C0.534502 1.33703 0.534502 1.9702 0.925026 2.36072L7.28899 8.72468ZM7.99609 7.01758H6.99609V8.01758H7.99609H8.99609V7.01758H7.99609Z" fill="currentColor"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </collapsible-content>
          </div>`;
}

// size用のチェックボックスHTML生成
function generateSizeHTML(sizes) {
  if (sizes.length === 0) return '';

  const checkboxesHTML = sizes.map((size, index) =>
    `<div class="checkbox-container">
                  <input
                    class="checkbox"
                    type="checkbox"
                    name="filter.v.option.size"
                    id="filter.v.option.size-${index + 1}"
                    value="${size}"
                  >

                  <label for="filter.v.option.size-${index + 1}">${size} &lrm;</label>
                </div>`
  ).join('\n                ');

  return `
          <div class="product-facet__filter-item">
            <button
              type="button"
              is="toggle-button"
              class="collapsible-toggle text--strong"
              aria-controls="facet-filter-filter.v.option.size"
              aria-expanded="false"
            >
              寸法<span class="c-collapsible-plus"></span></button
            ><collapsible-content animate-items="" id="facet-filter-filter.v.option.size" class="collapsible">
              <div class="collapsible__content collapsible__content--grid-4">
                ${checkboxesHTML}
              </div>
            </collapsible-content>
          </div>`;
}

// color用のチェックボックスHTML生成
function generateColorHTML(colors) {
  if (colors.length === 0) return '';
  const colorMapping = {};
  if(document.getElementById('colorMapping')) {
    const colorMappingElement = document.getElementById('colorMapping').textContent;
    const colorMappingObject = JSON.parse(colorMappingElement);

    colorMappingObject.forEach(item => {
      const colorItem = item.replace(/[\r\n]+/g, '').split(':');
      colorMapping[colorItem[0]] = colorItem[1];
    });
  }

  const checkboxesHTML = colors.map((color, index) => {
    const colorCode = colorMapping[color] || '#ffffff';
    const isWhite = color === '白';
    const isLightColor = ['ベージュ', '白', '黄'].includes(color);
    const containerClass = `checkbox-container${isLightColor ? ' checkbox-container--mark-black' : ''}${isWhite ? ' checkbox-container--white' : ''}`;

    return `<div class="${containerClass}">
                  <input
                    class="checkbox"
                    type="checkbox"
                    name="filter.p.m.item.color"
                    id="filter.p.m.item.color-${index + 1}"
                    value="${color}"
                  >

                  <label for="filter.p.m.item.color-${index + 1}" style="--background-color: ${colorCode}">${color} &lrm;</label>
                </div>`;
  }).join('\n                ');

  return `
          <div class="product-facet__filter-item">
            <button
              type="button"
              is="toggle-button"
              class="collapsible-toggle text--strong"
              aria-controls="facet-filter-filter.p.m.item.color"
              aria-expanded="false"
            >
              色<span class="c-collapsible-plus"></span></button
            ><collapsible-content animate-items="" id="facet-filter-filter.p.m.item.color" class="collapsible">
              <div class="collapsible__content collapsible__content--grid-4">
                ${checkboxesHTML}
              </div>
            </collapsible-content>
          </div>`;
}

// pattern_flg用のスイッチHTML生成
function generatePatternFlgHTML(hasPatternFlg) {
  if (!hasPatternFlg) return '';

  return `
          <div class="product-facet__filter-item">
            <div class="collapsible-toggle text--strong">
              <label for="filter.p.m.item.pattern_flg">無地</label>
              <input
                id="filter.p.m.item.pattern_flg"
                type="checkbox"
                class="switch-checkbox"
                name="filter.p.m.item.pattern_flg"
                value="1"
              >
            </div>
          </div>`;
}

// material用のチェックボックスHTML生成
function generateMaterialHTML(materials) {
  if (materials.length === 0) return '';

  const checkboxesHTML = materials.map((material, index) =>
    `<div class="checkbox-container">
                  <input
                    class="checkbox"
                    type="checkbox"
                    name="filter.p.m.item.material"
                    id="filter.p.m.item.material-${index + 1}"
                    value="${material}"
                  >

                  <label for="filter.p.m.item.material-${index + 1}">${material} &lrm;</label>
                </div>`
  ).join('\n                ');

  return `
          <div class="product-facet__filter-item">
            <button
              type="button"
              is="toggle-button"
              class="collapsible-toggle text--strong"
              aria-controls="facet-filter-filter.p.m.item.material"
              aria-expanded="false"
            >
              素材<span class="c-collapsible-plus"></span></button
            ><collapsible-content animate-items="" id="facet-filter-filter.p.m.item.material" class="collapsible">
              <div class="collapsible__content collapsible__content--grid-4">
                ${checkboxesHTML}
              </div>
            </collapsible-content>
          </div>`;
}

// price用のレンジ + 入力HTML生成（theme.js の PriceRange 構造に準拠）
function generatePriceHTML(priceRange) {
  if (!priceRange || (priceRange.min === 0 && priceRange.max === 0)) return '';

  const currencyCode = document.getElementById('currencyCode').textContent;
  if(currencyCode && currencyCode.includes('JPY') === false) {
    return '';
  }

  const min = Math.max(0, parseInt(priceRange.min, 10) || 0);
  const max = Math.max(min, parseInt(priceRange.max, 10) || 0);
  const lowerProgress = max === 0 ? 0 : Math.floor((min / max) * 100);
  const higherProgress = 100;

  return `
          <div class="product-facet__filter-item">
            <button
              type="button"
              is="toggle-button"
              class="collapsible-toggle text--strong"
              aria-controls="facet-filter-filter.v.price"
              aria-expanded="false"
            >
              価格<span class="c-collapsible-plus"></span></button
            ><collapsible-content animate-items id="facet-filter-filter.v.price" class="collapsible">
              <div class="collapsible__content">
                <price-range class="price-range">
                  <div class="price-range__range-group range-group" style="--range-min: ${lowerProgress}%; --range-max: ${higherProgress}%">
                    <input type="range" aria-label="価格(最小)" class="range" min="0" max="${max}" value="${min}">
                    <input type="range" aria-label="価格(最大)" class="range" min="0" max="${max}" value="${max}">
                  </div>
                  <div class="price-range__input-group">
                    <div class="price-range__input input-prefix text--xsmall">
                      <span class="input-prefix__value text--subdued">¥</span>
                      <input aria-label="価格(最小)" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.gte" id="filter.v.price.gte" min="0" max="${max}" placeholder="0">
                    </div>
                    <span class="price-range__delimiter text--small">〜</span>
                    <div class="price-range__input input-prefix text--xsmall">
                      <span class="input-prefix__value text--subdued">¥</span>
                      <input aria-label="価格(最大)" class="input-prefix__field" type="number" inputmode="numeric" name="filter.v.price.lte" id="filter.v.price.lte" min="0" max="${max}" placeholder="${max}">
                    </div>
                  </div>
                </price-range>
              </div>
            </collapsible-content>
          </div>`;
}

// フィルターフォーム全体を動的生成
function renderFilterForm(filterOptions) {
  const filterListContainer = document.querySelector('.product-facet__filter-list');
  if (!filterListContainer) {
    console.error('product-facet__filter-list not found');
    return;
  }

  // 各フィルターのHTMLを生成
  const htmlParts = [
    generateProductVendorHTML(filterOptions.product_vendor),
    generateProductTypeHTML(filterOptions.product_type),
    // generateSizeHTML(filterOptions.size),
    generateColorHTML(filterOptions.color),
    generatePriceHTML(filterOptions.price),
    generatePatternFlgHTML(filterOptions.pattern_flg),
    generateMaterialHTML(filterOptions.material)
  ].filter(html => html !== ''); // 空の要素を除外

  // フィルターリストを更新
  filterListContainer.innerHTML = htmlParts.join('\n');
}


// 絞り込み条件を集計してフォームを生成
function generateAndRenderFilters() {
  const filterOptions = generateFilterOptions();
  renderFilterForm(filterOptions);
}

// ------------------------------
// Start : URL初期パラメータの適用
// ------------------------------

// URLパラメータから初期絞り込み条件を適用
function applyInitialFiltersFromURL() {
  const urlParams = new URLSearchParams(window.location.search);

  // URLパラメータが存在するかチェック
  const hasFilterParams = Array.from(urlParams.keys()).some(key =>
    key.startsWith('filter.') || key === 'sort_by'
  );

  if (!hasFilterParams) {
    // パラメータがない場合は通常の初期表示
    renderInitialProducts();
    initInfiniteScrollForAll();
    return;
  }

  // sort_byパラメータがある場合は設定
  const sortBy = urlParams.get('sort_by');
  if (sortBy) {
    sortByValue = sortBy;
  }

  // フィルターパラメータを解析
  const searchParamsAsString = urlParams.toString();
  const filters = parseFilterParams(searchParamsAsString);

  // フィルター条件が存在するかチェック
  const hasActiveFilters = getActiveFiltersCount(filters) > 0;

  if (hasActiveFilters) {
    // アクティブフィルターを設定
    activeFilters = { ...filters };

    // フォームの状態を同期
    syncFormControlsFromURL(filters);

    // 絞り込みを適用
    const filtered = filterProducts(filters);
    updateProductDisplay(filtered);

    // アクティブフィルターを表示
    renderActiveFilters();
  } else {
    // フィルター条件がない場合は通常表示
    renderInitialProducts();
    initInfiniteScrollForAll();
  }
}

// URLパラメータに基づいてフォームコントロールを同期
function syncFormControlsFromURL(filters) {
  const form = document.getElementById('facet-filters-form');
  if (!form) return;

  // product_type (セレクトボックス)
  if (filters.product_type.length > 0) {
    const select = form.querySelector('select[name="filter.p.product_type"]');
    if (select) select.value = filters.product_type[0];
  }

  // size (チェックボックス)
  filters.size.forEach(value => {
    const input = form.querySelector(`input[name="filter.v.option.size"][value="${value}"]`);
    if (input) input.checked = true;
  });

  // color (チェックボックス)
  filters.color.forEach(value => {
    const input = form.querySelector(`input[name="filter.p.m.item.color"][value="${value}"]`);
    if (input) input.checked = true;
  });

  // pattern_flg (チェックボックス)
  if (filters.pattern_flg.length > 0) {
    const input = form.querySelector('input[name="filter.p.m.item.pattern_flg"]');
    if (input) input.checked = true;
  }

  // material (チェックボックス)
  filters.material.forEach(value => {
    const input = form.querySelector(`input[name="filter.p.m.item.material"][value="${value}"]`);
    if (input) input.checked = true;
  });

  // price
  if (filters.price && (filters.price.gte != null || filters.price.lte != null)) {
    const lower = form.querySelector('input[name="filter.v.price.gte"]');
    const upper = form.querySelector('input[name="filter.v.price.lte"]');
    if (lower && filters.price.gte != null) lower.value = String(filters.price.gte);
    if (upper && filters.price.lte != null) upper.value = String(filters.price.lte);

    const priceRange = document.querySelector('price-range');
    if (priceRange) {
      const lowerRange = priceRange.querySelector('.price-range__range-group input:first-child');
      const higherRange = priceRange.querySelector('.price-range__range-group input:last-child');
      const textLower = priceRange.querySelector('.price-range__input:first-child input');
      const textHigher = priceRange.querySelector('.price-range__input:last-child input');
      if (filters.price.gte != null) {
        if (textLower) textLower.value = String(filters.price.gte);
        if (lowerRange) {
          lowerRange.value = String(filters.price.gte);
          lowerRange.parentElement.style.setProperty('--range-min', `${(parseInt(lowerRange.value) / parseInt(lowerRange.max || '1')) * 100}%`);
        }
      }
      if (filters.price.lte != null) {
        if (textHigher) textHigher.value = String(filters.price.lte);
        if (higherRange) {
          higherRange.value = String(filters.price.lte);
          higherRange.parentElement.style.setProperty('--range-max', `${(parseInt(higherRange.value) / parseInt(higherRange.max || '1')) * 100}%`);
        }
      }
    }
  }
}

// ------------------------------
// Start : URL更新機能
// ------------------------------

// アクティブフィルターと並び替えに基づいてURLを更新
function updateURL() {
  const url = new URL(window.location.href);

  // 既存のフィルターパラメータを削除
  Array.from(url.searchParams.keys()).forEach(key => {
    if (key.startsWith('filter.')) {
      url.searchParams.delete(key);
    }
  });

  // アクティブフィルターをURLパラメータに追加
  Object.keys(activeFilters).forEach(filterType => {
    const values = activeFilters[filterType];

    if (Array.isArray(values) && values.length > 0) {
      values.forEach(value => {
        let paramName = '';

        if (filterType === 'product_type') {
          paramName = 'filter.p.product_type';
        } else if (filterType === 'size') {
          paramName = 'filter.v.option.size';
        } else if (filterType === 'color') {
          paramName = 'filter.p.m.item.color';
        } else if (filterType === 'pattern_flg') {
          paramName = 'filter.p.m.item.pattern_flg';
        } else if (filterType === 'material') {
          paramName = 'filter.p.m.item.material';
        }

        if (paramName) {
          url.searchParams.append(paramName, value);
        }
      });
    } else if (filterType === 'price' && values && (values.gte != null || values.lte != null)) {
      if (values.gte != null) url.searchParams.set('filter.v.price.gte', String(values.gte));
      if (values.lte != null) url.searchParams.set('filter.v.price.lte', String(values.lte));
    }
  });

  // 並び替えパラメータを追加
  if (sortByValue && sortByValue.length > 0) {
    url.searchParams.set('sort_by', sortByValue);
  } else {
    url.searchParams.delete('sort_by');
  }

  // URLを更新（ページリロードなし）
  window.history.pushState({ path: url.toString() }, '', url.toString());
  console.log('URL updated:', url.toString());
}